import { ACTION_REWARD_HISTORY_INFO, ACTION_REWARD_HISTORY_INFO_ERROR, ACTION_REWARD_HISTORY_INFO_SUCCESS } from "../actions";

const initState = {
    isLoading: false,
    erro_msg: undefined,
    data: undefined
}


export const getRewardHistoryInfoReducer = (state = initState, action = {}) => {
    switch (action.type) {
        case ACTION_REWARD_HISTORY_INFO:
            return { ...state, isLoading: true, erro_msg: undefined }
        case ACTION_REWARD_HISTORY_INFO_SUCCESS:
            return { ...state, isLoading: false, erro_msg: undefined, data: action.payload.data }
        case ACTION_REWARD_HISTORY_INFO_ERROR:
            return { ...state, isLoading: false, erro_msg: action.payload.msg };
        default:
            return state;
    }
}